import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  MenuItem,
  CircularProgress,
  Modal,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { SvgIcon, SvgIconProps } from "@mui/material";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import CloseIcon from "@mui/icons-material/Close";
import type React from "react";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import Autocomplete from "@mui/material/Autocomplete";
import debounce from "lodash.debounce";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import DynamicTable from "../../../components/Dynamic-table";
import DeleteConfirmationModal from "../../../components/Modals/delete-modal";
import PrintIcon from "@mui/icons-material/Print";
import jsPDF from "jspdf";
import jsbarcode from "jsbarcode";
import { useLocation, useNavigate } from "react-router-dom";

const TrashIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 64 64">
      {/* Head */}
      <circle cx="46" cy="6" r="4" fill="black" />
      {/* Arm */}
      <path d="M44 10 L26 16 L28 20 L44 14 Z" fill="black" />
      {/* Body */}
      <path d="M44 10 L36 28 L44 28 L50 14 Z" fill="black" />
      {/* Right Leg */}
      <path d="M44 28 L46 50 L50 50 L48 28 Z" fill="black" />
      {/* Left Leg */}
      <path d="M36 28 L36 50 L40 50 L44 28 Z" fill="black" />
      {/* Bin */}
      <g stroke="black" strokeWidth="1" fill="none">
        <rect x="10" y="24" width="12" height="20" />
        <line x1="10" y1="24" x2="22" y2="44" />
        <line x1="22" y1="24" x2="10" y2="44" />
        <line x1="10" y1="30" x2="22" y2="30" />
        <line x1="10" y1="36" x2="22" y2="36" />
      </g>
      {/* Trash pieces */}
      <polygon points="14,26 16,24 18,26" fill="black" />
      <polygon points="12,28 14,26 16,28" fill="black" />
    </SvgIcon>
  );
};

// export default CustomTrashIcon;

const ErrorText = ({ message }: { message: string }) => (
  <Typography sx={{ color: "red", fontSize: "11px" }}>{message}</Typography>
);

interface Donor {
  _id: string;
  donorId: string;
  name?: string;
  age?: string;
  gender?: string;
  cellNo?: string;
  bloodGroup?: string;
}

const formatDate = (dateString: string): string => {
  try {
    if (!dateString) return "N/A";
    const match = String(dateString).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      const year = Number(match[1]);
      const month = Number(match[2]);
      const day = Number(match[3]);
      return new Date(year, month - 1, day).toLocaleDateString();
    }
    return new Date(dateString).toLocaleDateString();
  } catch {
    return "N/A";
  }
};

const DonorBagExpiry: React.FC = () => {
  const now = new Date();
  const expiryDate = new Date(now);
  expiryDate.setMonth(now.getMonth() + 1);
  // expiryDate.setDate(now.getDate() + 5);
  const [formData, setFormData] = useState({
    donorId: "",
    collectionDate: now.toISOString().slice(0, 16),
    issueDate: "",
    expiryDate: expiryDate.toISOString().slice(0, 16),
    bloodGroup: "",
    bagNo: "",
    rhFactor: "",
    bloodCell: "",
    bloodQuantity: "",
    du: "",
    bagStatus: "ACTIVE",
  });

  const [donorOptions, setDonorOptions] = useState<any[]>([]);
  const [donorLoading, setDonorLoading] = useState(false);
  const [editData, setEditData] = useState<any>(null);
  const [tableData, setTableData] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState<string>("");
  const [searchInput, setSearchInput] = useState("");
  const [searchType, setSearchType] = useState("donorId");
  const [donorInputValue, setDonorInputValue] = useState("");
  const [resetKey, setResetKey] = useState(0);
  const [recentDonors, setRecentDonors] = useState<any[]>([]);
  const [selectedDonor, setSelectedDonor] = useState<any>(null);
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [pdfContent, setPdfContent] = useState<string>("");
  const [currentPrintBag, setCurrentPrintBag] = useState(null);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDonorSelected, setIsDonorSelected] = useState(false);

  const [isDisposeModalOpen, setIsDisposeModalOpen] = useState(false);
  const [disposeBagId, setDisposeBagId] = useState<string>("");
  const [disposalReason, setDisposalReason] = useState<string>("");

  const location = useLocation();
  const { state } = location;
  const { idd, data } = state || {};

  console.log("Donor ID:", idd, "Data:", data);
  const pathname = location.pathname;
  const navigate = useNavigate();
  const [errors, setErrors] = useState({
    donorId: "",
    collectionDate: "",
    expiryDate: "",
    bloodGroup: "",
    rhFactor: "",
    du: "",
    bloodCell: "",
    bloodQuantity: "",
  });

  // Fetch recent donors from the new API
  const fetchRecentDonors = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BLOOD_BANK}/donor/getDonors`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          params: {
            pageNo: 1,
            count: 5,
          },
        }
      );
      setRecentDonors(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching recent donors", error);
    }
  };

  // Fetch donor options
  const fetchDonorOptions = async (search: string) => {
    if (!search) return;
    try {
      setDonorLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BLOOD_BANK}/donor/getAllDonorsByFilter`,
        {
          params: { search, searchBy: searchType },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setDonorOptions(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching donors", error);
      toast.error("Failed to fetch donors");
      setDonorOptions([]);
    } finally {
      setDonorLoading(false);
    }
  };

  const debouncedFetch = debounce(fetchDonorOptions, 400);

  const fetchTableData = async () => {
    try {
      // Build params object conditionally
      const params: any = {
        pageNo: page + 1,
        count: rowsPerPage,
        //sort: "descending", // Set sort to descending
        sortByExpiryDate: "accending", // Sort by daysToExpire field
      };

      // Only add search if it has a value
      if (searchTerm && searchTerm.trim()) {
        params.search = searchTerm.trim();
      }

      // Only add status if it has a value (not empty string)
      if (statusFilter && statusFilter.trim()) {
        params.status = statusFilter;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BLOOD_BANK}/bag-generation/findAllBags`,
        {
          params,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.data?.data && response.data.data.length > 0) {
        // Ensure donor data is fully populated
        const populatedTableData = response.data?.data.map((bag: any) => ({
          ...bag,
          donorData: bag.donorData || { name: "Unknown", donorId: "N/A" },
        }));

        setTableData(populatedTableData || []);
        setTotal(response.data?.totalCount || 0);
      } else {
        setTableData([]);
        setTotal(0);
        toast.error("No bags data available");
      }
    } catch (error) {
      console.error("Fetch Table Data Error:", error);
      setTableData([]);
      setTotal(0);
      toast.error("Failed to fetch data");
    }
  };

  useEffect(() => {
    fetchTableData();
  }, [page, rowsPerPage, statusFilter, searchTerm]);

  const resetForm = () => {
    const currentDate = new Date();
    const expiryDate = new Date(currentDate);
    expiryDate.setDate(currentDate.getDate() + 5);

    setFormData({
      donorId: "",
      collectionDate: new Date().toISOString().slice(0, 10),
      issueDate: "",
      expiryDate: expiryDate.toISOString().slice(0, 16),
      bloodGroup: "",
      bagNo: "",
      rhFactor: "",
      du: "",
      bloodQuantity: "",
      bloodCell: "",
      bagStatus: "ACTIVE",
    });
    setDonorInputValue("");
    setSearchType("donorId");
    setResetKey(prev => prev + 1);
    setEditData(null);
    setSelectedDonor(null);
    setIsDonorSelected(false);
    setErrors({
      donorId: "",
      collectionDate: "",
      expiryDate: "",
      bloodGroup: "",
      rhFactor: "",
      du: "",
      bloodCell: "",
      bloodQuantity: "",
    });
  };

  // ...existing code...
  const filteredData = tableData?.filter(item => {
    const donorId = String(item?.donorData?.donorId || "");
    const searchLower = searchTerm.toLowerCase();
    // Only filter by donorId/search, NOT by status
    return !searchTerm || donorId.toLowerCase().includes(searchLower);
  });
  // ...existing code...

  // 5. Alternative approach - if you want to handle "All" explicitly
  const handleStatusFilterChange = (value: string) => {
    setStatusFilter(value);
    setPage(0);

    // Optional: Immediately fetch data
    setTimeout(() => {
      fetchTableData();
    }, 0);
  };
  const handleSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const {
        donorId,
        collectionDate,
        expiryDate,
        issueDate,
        bloodGroup,
        bagNo,
        rhFactor,
        du,
        bloodCell,
        bloodQuantity,
      } = formData;

      setErrors({
        donorId: "",
        collectionDate: "",
        expiryDate: "",
        bloodGroup: "",
        rhFactor: "",
        du: "",
        bloodCell: "",
        bloodQuantity: "",
      });

      let hasErrors = false;
      const newErrors = { ...errors };

      // if (!donorId?.trim()) {
      //   toast.error("Please select a donor.");
      //   setIsSubmitting(false);
      //   return;
      // }

      if (!collectionDate) {
        newErrors.collectionDate = "Please provide collection date.";
        hasErrors = true;
      }

      const now = new Date();
      const collection = new Date(collectionDate);
      const expiry = new Date(expiryDate);
      const issue = issueDate ? new Date(issueDate) : null;

      if (collection > now) {
        toast.error("Collection date cannot be in the future.");
        setIsSubmitting(false);
        return;
      }

      if (!expiryDate) {
        newErrors.expiryDate = "Please provide expiry date.";
        hasErrors = true;
      }
      if (issue && (issue < collection || issue > expiry)) {
        toast.error("Issue date must be between collection and expiry dates.");
        setIsSubmitting(false);
        return;
      }

      if (!bloodGroup?.trim()) {
        newErrors.bloodGroup = "Please select a Blood Group.";
        hasErrors = true;
      }

      if (!rhFactor?.trim()) {
        newErrors.rhFactor = "Please select RH Factor.";
        hasErrors = true;
      }

      // if (!du?.trim()) {
      //   newErrors.du = "Please select DU factor.";
      //   hasErrors = true;
      // }

      // if (!bloodCell?.trim()) {
      //   newErrors.bloodCell = "Please select Blood Product.";
      //   hasErrors = true;
      // }

      if (hasErrors) {
        setErrors(newErrors);
        setIsSubmitting(false);
        return;
      }

      const currentBagData = editData
        ? tableData.find(bag => bag?._id === editData)
        : null;

      const donorData = selectedDonor
        ? {
            name: selectedDonor.name || data.name || "Unknown",
            donorId: selectedDonor.donorId || idd || "N/A",
            age: selectedDonor.age || data.age || "N/A",
            gender: selectedDonor.gender || data.gender || "N/A",
            cellNo: selectedDonor.cellNo || data.cellNo || "N/A",
          }
        : currentBagData?.donorData || { name: "Unknown" };

      const payload: any = {
        donorId,
        collectionDate: collection.toISOString(),
        expiryDate: expiry.toISOString(),
        bloodGroup,
        bagNo,
        rhFactor,
        du,
        bloodQuantity,
        bloodCell,
        bagStatus: formData.bagStatus,
        donorData: donorData,
        extra: {},
      };

      if (issue) {
        payload.issueDate = issue.toISOString();
      }

      const url = editData
        ? `${process.env.REACT_APP_BLOOD_BANK}/bag-generation/updateBagById/${editData}`
        : `${process.env.REACT_APP_BLOOD_BANK}/bag-generation/createBag`;

      const method = editData ? axios.put : axios.post;

      const response = await method(url, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (editData) {
        setTableData(prevData =>
          prevData.map(bag =>
            bag?._id === editData ? { ...bag, ...payload } : bag
          )
        );
      } else {
        await fetchTableData();
      }

      toast.success(response.data?.message || "Bag saved successfully");
      if (!editData) {
        const newBagData = response.data?.data;
        if (newBagData) {
          const bagDataWithDonor = {
            ...newBagData,
            donorData: donorData,
          };
          setCurrentPrintBag(bagDataWithDonor);
          generatePDF(bagDataWithDonor, false);
        }
      }
      resetForm();
    } catch (error: any) {
      console.error("Submit Error:", error);
      toast.error(
        error.response?.data?.message?.join(", ") ||
          error.message ||
          "Something went wrong"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    console.log("useEffect running, state:", state);
    // Fetch recent donors
    fetchRecentDonors();

    // Check if state contains donor data from navigation
    if (state && state.idd && state.data) {
      console.log("State data found, pre-populating form");
      const { idd, data } = state;

      // Extract blood group and RH factor from data.bloodGroup (e.g., "A+", "B-")
      let bloodGroup = "";
      let rhFactor = "";
      if (data?.bloodGroup) {
        const match = data.bloodGroup.match(/^(A|B|AB|O)([+-])$/);
        if (match) {
          bloodGroup = match[1]; // e.g., "A"
          rhFactor = match[2]; // e.g., "+"
        }
      }

      // Set current date and expiry date (5 days from now)
      const currentDate = new Date();
      const expiryDate = new Date(currentDate);
      expiryDate.setDate(currentDate.getDate() + 5);

      // Set selected donor
      setSelectedDonor({
        _id: idd,
        name: data.name || "N/A",
        age: data.age || "N/A",
        gender: data.gender || "N/A",
        cellNo: data.cellNo || "N/A",
        donorId: data.donorId || "N/A",
        bloodGroup: data.bloodGroup || "N/A",
      });

      // Update formData with donor details and defaults
      // setFormData(data);
      setFormData({
        donorId: idd,
        collectionDate: data.collectionDate || currentDate.toISOString(),
        issueDate: data.issueDate || "",
        expiryDate: data.expiryDate || expiryDate.toISOString(),
        bloodGroup: data.bloodGroup || "",
        bagNo: data.bagNo || "",
        rhFactor: data.rhFactor || "",
        du: data.du || "",
        bloodCell: data.bloodCell || "",
        bloodQuantity: data.bloodQuantity || "",
        bagStatus: "ACTIVE",
      });

      // Mark donor as selected
      setIsDonorSelected(true);
      console.log("isDonorSelected set to true");
      // setEditData(idd);

      // Set donor input value for display in Autocomplete
      setDonorInputValue(`${data.donorId}-${data.name || "Unknown"}`);
    } else {
      console.log("No state data, form remains empty");
    }
  }, []);
  // Flatten the data to show each blood component as a separate row
  const flattenedData = filteredData?.reduce((acc, item) => {
    if (Array.isArray(item.bloodCell)) {
      // Create a row for each blood component
      item.bloodCell.forEach((component: any) => {
        acc.push({
          ...item,
          bloodCell: component, // Override with the specific component
        });
      });
    } else {
      // Single component, add as is
      acc.push(item);
    }
    return acc;
  }, []);
  // useEffect(() => {
  //     fetchTableData();
  // }, [page, rowsPerPage, statusFilter]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleEditClick = (id: string, data: any) => {
    setEditData(id);
    navigate("/donor-bag");
    setFormData({
      donorId: data.donorId,
      collectionDate: data.collectionDate,
      issueDate: data.issueDate || "",
      expiryDate: data.expiryDate,
      bloodGroup: data.bloodGroup,
      bagNo: data.bagNo,
      bloodCell: data.bloodCell,
      bloodQuantity: data.bloodQuantity,
      rhFactor: data.rhFactor,
      du: data.du,
      bagStatus: data.bagStatus,
    });
    setSelectedDonor({
      name: data.donorData?.name || "N/A",
      age: data.donorData?.age || "N/A",
      gender: data.donorData?.gender || "N/A",
      cellNo: data.donorData?.cellNo || "N/A",
      donorId: data.donorData?.donorId || "N/A",
      bloodGroup: data.bloodGroup || "N/A",
    });
    setIsDonorSelected(true);
  };

  const handleDeleteClick = (id: string) => {
    setSelectedItemId(id);
    setIsDeleteModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_BLOOD_BANK}/bag-generation/deleteBagById/${selectedItemId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      toast.success("Deleted successfully");
      fetchTableData();
    } catch (error: any) {
      toast.error(error.message || "Delete failed");
    }
    setIsDeleteModalOpen(false);
  };

  // const generatePDF = (data: any, print = false) => {
  //   try {
  //     if (!data) {
  //       console.error("No data provided for PDF generation");
  //       toast.error("Failed to generate PDF - missing data");
  //       return;
  //     }

  //     console.log("Generating PDF for data:", data);

  //     const doc = new jsPDF({
  //       orientation: "landscape",
  //       unit: "mm",
  //       format: [65, 65],
  //     });

  //     const margin = 3;
  //     const pageWidth = 65;
  //     let yPos = 15;

  //     // HEADER - Blood Group
  //     doc.setFont("helvetica", "bold");
  //     doc.setFontSize(32);
  //     doc.setTextColor(0);
  //     doc.text(`${data.bloodGroup || "N/A"}`, margin, yPos);

  //     // RH Factor tag
  //     const rhText = data.rhFactor === "+" ? "+" : "-";
  //     doc.setFontSize(8);
  //     doc.setDrawColor(0);
  //     doc.setFillColor(0, 0, 0);
  //     doc.setTextColor(255);
  //     const rhX = margin + 9;
  //     const rhY = yPos - 6;
  //     const rhWidth = doc.getTextWidth(rhText) + 4;
  //     const rhHeight = 6;
  //     doc.roundedRect(rhX, rhY, rhWidth, rhHeight, 1, 1, "F");
  //     doc.text(rhText, rhX + 2, rhY + 4.5);

  //     // Blood Cell Type
  //     if (data.bloodCell) {
  //       yPos += 8;
  //       doc.setFontSize(10);
  //       doc.setTextColor(187, 10, 30);
  //       doc.setFont("helvetica", "bold");
  //       doc.text(`${data.bloodCell.toUpperCase()}`, margin, yPos);
  //       doc.setDrawColor(187, 10, 30);
  //       doc.line(margin, yPos + 1, margin + 15, yPos + 1);
  //     }

  //     // DETAILS SECTION - Two-column layout with values in same column
  //     yPos += 8;
  //     doc.setTextColor(0);
  //     doc.setFontSize(8);

  //     const col1LabelX = margin;
  //     const col1ValueX = margin + 15;
  //     const col2LabelX = margin + 32;
  //     const col2ValueX = margin + 45;
  //     doc.setFont("helvetica", "bold");
  //     doc.text("Donor:", col1LabelX, yPos);
  //     doc.setFont("helvetica", "normal");
  //     const donorName = data.donorData?.name || "Unknown";
  //     doc.text(donorName, col1ValueX, yPos);
  //     doc.setFont("helvetica", "bold");
  //     doc.text("Quantity:", col2LabelX, yPos);
  //     doc.setFont("helvetica", "normal");
  //     doc.text(`${data.bloodQuantity || "N/A"} ml`, col2ValueX, yPos);

  //     yPos += 5;
  //     doc.setFont("helvetica", "bold");
  //     doc.text("Collected:", col1LabelX, yPos);
  //     doc.setFont("helvetica", "normal");
  //     doc.text(`${formatDate(data.collectionDate) || "N/A"}`, col1ValueX, yPos);

  //     doc.setFont("helvetica", "bold");
  //     doc.text("Expires:", col2LabelX, yPos);
  //     doc.setFont("helvetica", "normal");
  //     const expiryDate = formatDate(data.expiryDate) || "N/A";
  //     doc.text(expiryDate, col2ValueX, yPos);

  //     yPos += 5;
  //     doc.setFont("helvetica", "bold");
  //     doc.text("Bag No:", col1LabelX, yPos);
  //     doc.setFont("helvetica", "normal");
  //     doc.text(`${data.bagNo || "N/A"}`, col1ValueX, yPos);

  //     // BARCODE
  //     yPos += 8;
  //     try {
  //       const barcodeCanvas = document.createElement("canvas");
  //       const barcodeValue = data.bagNo || "UNKNOWN";
  //       jsbarcode(barcodeCanvas, barcodeValue, {
  //         format: "CODE128",
  //         width: 1.2,
  //         height: 15,
  //         fontSize: 7,
  //         displayValue: true,
  //         margin: 0,
  //       });
  //       const barcodeDataUrl = barcodeCanvas.toDataURL("image/png");
  //       const barcodeWidth = 36;
  //       const barcodeX = (pageWidth - barcodeWidth) / 2;
  //       doc.addImage(barcodeDataUrl, "PNG", barcodeX, yPos, barcodeWidth, 20);

  //       if (data.bagNo) {
  //         yPos += 20;
  //         doc.setFontSize(8);
  //         doc.setTextColor(187, 10, 30);
  //         doc.setFont("helvetica", "bold");
  //         const bagNoText = `Bag No: ${data.bagNo}`;
  //         const bagNoTextWidth = doc.getTextWidth(bagNoText);
  //         const bagNoX = (pageWidth - bagNoTextWidth) / 2;
  //         doc.text("Bag No:", bagNoX, yPos);
  //         doc.setFont("helvetica", "normal");
  //         doc.text(
  //           `${data.bagNo}`,
  //           bagNoX + doc.getTextWidth("Bag No: "),
  //           yPos
  //         );
  //       }
  //     } catch (barcodeError) {
  //       console.error("Barcode generation failed:", barcodeError);
  //       yPos += 8;
  //       doc.setFontSize(8);
  //       doc.setTextColor(0);
  //       doc.setFont("helvetica", "bold");
  //       const bagNoText = `Bag No: ${data.bagNo || "UNKNOWN"}`;
  //       const bagNoTextWidth = doc.getTextWidth(bagNoText);
  //       const bagNoX = (pageWidth - bagNoTextWidth) / 2;
  //       doc.text("Bag No:", bagNoX, yPos);
  //       doc.setFont("helvetica", "normal");
  //       doc.text(
  //         `${data.bagNo || "UNKNOWN"}`,
  //         bagNoX + doc.getTextWidth("Bag No: "),
  //         yPos
  //       );
  //     }

  //     if (print) {
  //       window.open(doc.output("bloburl"), "_blank");
  //     } else {
  //       const pdfDataUri = doc.output("datauristring");
  //       setPdfContent(pdfDataUri);
  //       setCurrentPrintBag(data);
  //       setPreviewModalOpen(true);
  //     }
  //   } catch (error) {
  //     console.error("PDF Generation Error:", error);
  //     toast.error("Failed to generate PDF");
  //   }
  // };
  const generatePDF = (data: any, print = false) => {
    try {
      if (!data) {
        console.error("No data provided for PDF generation");
        toast.error("Failed to generate PDF - missing data");
        return;
      }

      console.log("Generating PDF for data:", data);

      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: [65, 90], // Adjusted height to accommodate both designs
      });

      const margin = 3;
      const pageWidth = 65;
      let yPos = 5;

      // HEADER - "NATIONAL BLOOD BANK" (Blood Bag Section)
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.setTextColor(0);
      const headerText = "NATIONAL BLOOD BANK";
      const headerTextWidth = doc.getTextWidth(headerText);
      const headerX = (pageWidth - headerTextWidth) / 2;
      doc.text(headerText, headerX, yPos);

      // SUBHEADER - "National Hospital & Cardiac Complex"
      yPos += 4;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(6);
      const subheaderText = "National Hospital & Cardiac Complex";
      const subheaderTextWidth = doc.getTextWidth(subheaderText);
      const subheaderX = (pageWidth - subheaderTextWidth) / 2;
      doc.text(subheaderText, subheaderX, yPos);

      // SUBHEADER 2 - "Rahim Yar Khan, Punjab."
      yPos += 3;
      const subheader2Text = "Rahim Yar Khan, Punjab.";
      const subheader2TextWidth = doc.getTextWidth(subheader2Text);
      const subheader2X = (pageWidth - subheader2TextWidth) / 2;
      doc.text(subheader2Text, subheader2X, yPos);

      // Blood Cell Type - "WHOLE BLOOD"
      yPos += 5;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      const bloodCellText = data.bloodCell
        ? data.bloodCell.toUpperCase()
        : "WHOLE BLOOD";
      const bloodCellTextWidth = doc.getTextWidth(bloodCellText);
      const bloodCellX = (pageWidth - bloodCellTextWidth) / 2;
      doc.text(bloodCellText, bloodCellX, yPos);
      doc.setDrawColor(0);
      doc.line(margin, yPos + 1, pageWidth - margin, yPos + 1);

      // DONOR NAME -
      yPos += 5;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      const donorName = data.donorData?.name
        ? `${data.donorData.name.toUpperCase()}`
        : "UNKNOWN";
      const donorNameWidth = doc.getTextWidth(donorName);
      const donorNameX = margin + 1;
      doc.text(donorName, donorNameX, yPos);

      // DETAILS SECTION - Age, Gender, Blood Group
      yPos += 5;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);

      // Age and Gender
      const ageText = `Age: ${data.donorData?.age || "N/A"}`;
      const genderText = `Gender: ${data.donorData?.gender || "N/A"}`;
      doc.text(ageText, margin, yPos);
      doc.text(genderText, margin + 20, yPos);

      // Blood Group - Large "O" on the right
      doc.setFont("helvetica", "bold");
      doc.setFontSize(20);
      doc.text(`${data.bloodGroup || "N/A"}`, pageWidth - margin - 5, yPos - 2);

      // RH Factor - "POSITIVE" below Blood Group
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text(
        `${data.rhFactor === "+" ? "POSITIVE" : "NEGATIVE"}`,
        pageWidth - margin - 10,
        yPos + 2
      );

      // Bag No
      yPos += 5;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(7);
      doc.text(`Bag No: ${data.bagNo || "N/A"}`, margin, yPos);

      // Collection and Expiry Dates
      yPos += 5;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text(`Collection Date`, margin, yPos);
      doc.text(
        `${formatDate(data.collectionDate) || "N/A"}`,
        margin + 20,
        yPos
      );

      yPos += 4;
      doc.text(`Expiry Date`, margin, yPos);
      doc.text(`${formatDate(data.expiryDate) || "N/A"}`, margin + 15, yPos);

      // BARCODE
      yPos += 6;
      try {
        const barcodeCanvas = document.createElement("canvas");
        const barcodeValue = data.bagNo || "UNKNOWN";
        jsbarcode(barcodeCanvas, barcodeValue, {
          format: "CODE128",
          width: 1,
          height: 15,
          fontSize: 7,
          displayValue: true,
          margin: 0,
        });
        const barcodeDataUrl = barcodeCanvas.toDataURL("image/png");
        const barcodeWidth = 40;
        const barcodeX = (pageWidth - barcodeWidth) / 2;
        doc.addImage(barcodeDataUrl, "PNG", barcodeX, yPos, barcodeWidth, 10);
      } catch (barcodeError) {
        console.error("Barcode generation failed:", barcodeError);
        yPos += 5;
        doc.setFontSize(7);
        doc.setTextColor(0);
        doc.setFont("helvetica", "normal");
        const bagNoText = `Bag No: ${data.bagNo || "UNKNOWN"}`;
        const bagNoTextWidth = doc.getTextWidth(bagNoText);
        const bagNoX = (pageWidth - bagNoTextWidth) / 2;
        doc.text(bagNoText, bagNoX, yPos);
      }

      // FOOTER - Screening and Storage Info
      yPos += 15;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(5);
      const footerText =
        // "This blood product has been screened for HBsAg, HCV, HIV, MP & VDRL. Store between 2 - 8°C.";
        `This blood product has been screened for HBsAg, HCV, HIV, MP & VDRL. ${data.bagComponent.storageMessage}`;
      const footerLines = doc.splitTextToSize(
        footerText,
        pageWidth - margin * 2
      );
      doc.text(footerLines, margin, yPos);

      if (print) {
        window.open(doc.output("bloburl"), "_blank");
      } else {
        const pdfDataUri = doc.output("datauristring");
        setPdfContent(pdfDataUri);
        setCurrentPrintBag(data);
        setPreviewModalOpen(true);
      }
    } catch (error) {
      console.error("PDF Generation Error:", error);
      toast.error("Failed to generate PDF");
    }
  };

  const handlePrintClick = (index: any) => {
    const selectedBag = tableData[index];
    if (selectedBag) {
      if (!selectedBag.donorData || !selectedBag.donorData.name) {
        console.warn("Donor data missing or incomplete, using available data");
      }
      setCurrentPrintBag(selectedBag);
      generatePDF(selectedBag, false);
    } else {
      toast.error("Could not find the selected bag");
    }
  };

  const handlePrintFromPreview = () => {
    if (currentPrintBag) {
      generatePDF(currentPrintBag, true);
    } else {
      toast.error("No bag data available to print");
    }
  };

  const handleClosePreviewModal = () => {
    navigate("/patient-slip");
    setPreviewModalOpen(false);
  };

  return (
    <Box>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "#FFFFFF",
              borderRadius: 0.5,
              padding: 0.5,
            }}
          >
            <Grid item>
              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", fontSize: "18px", mb: 1 }}
              >
                {pathname == "/blood-bags"
                  ? "Blood Bags"
                  : "Bag Close To Expire"}
              </Typography>
            </Grid>
            <Grid item>
              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField
                  size="small"
                  className="custom-input"
                  placeholder="Search by donor ID..."
                  value={searchTerm}
                  onChange={e => {
                    setSearchTerm(e.target.value);
                    setPage(0);
                  }}
                  onKeyDown={e => {
                    if (e.key === "Enter") {
                      setPage(0);
                      fetchTableData();
                    }
                  }}
                  sx={{ width: 200 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ color: "action.active" }} />
                      </InputAdornment>
                    ),
                    endAdornment: searchTerm ? (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="clear search"
                          onClick={() => {
                            setSearchTerm("");
                            setPage(0);
                          }}
                          edge="end"
                          size="small"
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                />

                {/* <TextField
                                    select
                                    label="Filter by Status"
                                    className="search-field"
                                    value={statusFilter}
                                    onChange={(e) => handleStatusFilterChange(e.target.value)}
                                    size="small"
                                    sx={{
                                        width: 200,
                                        backgroundColor: "#F5F5FB",
                                        borderRadius: "8px",
                                    }}
                                    InputProps={{
                                        endAdornment: statusFilter ? (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="clear filter"
                                                    onClick={() => handleStatusFilterChange("")}
                                                    edge="end"
                                                    size="small"
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            </InputAdornment>
                                        ) : null,
                                    }}
                                >
                                    <MenuItem value="">All</MenuItem>
                                    <MenuItem value="ACTIVE">Active</MenuItem>
                                    <MenuItem value="ISSUED">Issued</MenuItem>
                                    <MenuItem value="EXPIRED">Expired</MenuItem>
                                    <MenuItem value="DISPOSED">Disposed</MenuItem>
                                </TextField> */}
              </Box>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              background: "#FFFFFF",
              borderRadius: 2,
              p: 2,
              boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
              height: "485px",
              width: "100%", // Full width
              maxWidth: "100%", // Prevents overflow
              mx: "auto", // Center horizontally
              overflowX: "auto", // Horizontal scroll if needed
            }}
          >
            <DynamicTable
              headers={[
                "SN",
                "Donor Name",
                "Donor ID",
                "Bag No",
                "Blood Group",
                // "DU",
                "Blood Product",
                "Blood Quantity",
                "Status",
                "Expired At",
                "Remaining Days",
                // "Actions",
              ]}
              data={filteredData?.map((item, idx) => [
                page * rowsPerPage + idx + 1,
                item.donorData?.name,
                item.donorData?.donorId || "N/A",
                item.bagNo || "N/A",
                item.bloodGroup + item.rhFactor || "-",
                // item.du,
                Array.isArray(item.bloodCell)
                  ? item.bloodCell[idx % item.bloodCell.length] ||
                    item.bloodCell[0]
                  : item.bloodCell,
                item.bloodQuantity ? `${item.bloodQuantity} ml` : "",
                item.bagStatus,
                item.expiredAt,
                typeof item.daysToExpire !== "undefined"
                  ? `${item.daysToExpire} days`
                  : "N/A",
              ])}
              loading={false}
              page={page}
              rowsPerPage={rowsPerPage}
              totalRows={total}
              handleChangePage={(e: any, newPage: any) => setPage(newPage)}
              handleChangeRowsPerPage={(e: any) => {
                setRowsPerPage(Number.parseInt(e.target.value, 10));
                setPage(0);
              }}
              height={"63.5vh"}
              // actionButtons={[
              //     {
              //         icon: <EditIcon sx={{ color: "#FFB800", cursor: "pointer" }} />,
              //         onClick: (index: any) =>
              //             handleEditClick(tableData[index]?._id, tableData[index]),
              //     },
              //     {
              //         icon: <DeleteIcon sx={{ color: "#FF5454", cursor: "pointer" }} />,
              //         onClick: (index: any) => handleDeleteClick(tableData[index]?._id),
              //     },
              //     {
              //         icon: <PrintIcon sx={{ color: "#4CAF50", cursor: "pointer" }} />,
              //         onClick: (index: any) => handlePrintClick(index),
              //     },
              //     {
              //         icon: (
              //             <IconButton
              //                 color="error"
              //                 size="small"
              //                 sx={{ ml: 1 }}
              //                 title="Dispose"
              //             >
              //                 <TrashIcon />
              //             </IconButton>
              //         ),
              //         onClick: (index: any) => {
              //             setDisposeBagId(tableData[index]?._id);
              //             setIsDisposeModalOpen(true);
              //         },
              //     },
              // ]}
            />
            {filteredData.length === 0 && (
              <div
                style={{ textAlign: "center", padding: "16px", color: "#999" }}
              >
                <strong>No data available</strong>
              </div>
            )}
          </Box>
        </Grid>
      </Grid>

      <Modal
        open={previewModalOpen}
        onClose={handleClosePreviewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "5px",
            width: "300px",
          }}
        >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            PDF Preview
          </Typography>
          <embed src={pdfContent} width="100%" height="400px" />
          <Box display="flex" justifyContent="center" mt={2}>
            <Button
              onClick={handlePrintFromPreview}
              variant="contained"
              color="primary"
              sx={{ mr: 1 }}
            >
              Print
            </Button>
            <Button
              onClick={handleClosePreviewModal}
              variant="contained"
              color="secondary"
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>

      <DeleteConfirmationModal
        open={isDeleteModalOpen}
        handleClose={() => setIsDeleteModalOpen(false)}
        handleConfirm={handleDeleteConfirm}
      />

      <Modal
        open={isDisposeModalOpen}
        onClose={() => setIsDisposeModalOpen(false)}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "5px",
            width: "350px",
          }}
        >
          <Typography variant="h6" mb={2}>
            Dispose Blood Bag
          </Typography>
          <TextField
            label="Disposal Reason"
            value={disposalReason}
            onChange={e => setDisposalReason(e.target.value)}
            fullWidth
            multiline
            minRows={2}
            sx={{ mb: 2 }}
          />
          <Box display="flex" justifyContent="flex-end" gap={1}>
            <Button
              variant="contained"
              color="error"
              onClick={async () => {
                if (!disposalReason.trim()) {
                  toast.error("Please enter a disposal reason");
                  return;
                }
                try {
                  await axios.put(
                    `${process.env.REACT_APP_BLOOD_BANK}/bag-generation/disposedBagById/${disposeBagId}`,
                    { disposalReason },
                    {
                      headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                          "token"
                        )}`,
                      },
                    }
                  );
                  toast.success("Bag disposed successfully");
                  setIsDisposeModalOpen(false);
                  setDisposalReason("");
                  // Update the status locally
                  setTableData(prev =>
                    prev.map(bag =>
                      bag._id === disposeBagId
                        ? { ...bag, bagStatus: "DISPOSED" }
                        : bag
                    )
                  );
                  // Optionally, you can still call fetchTableData() if you want to sync with backend
                  // fetchTableData();
                } catch (error: any) {
                  toast.error(
                    error.response?.data?.message ||
                      error.message ||
                      "Dispose failed"
                  );
                }
              }}
            >
              Confirm Dispose
            </Button>

            <Button
              variant="outlined"
              onClick={() => setIsDisposeModalOpen(false)}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default DonorBagExpiry;
